export default "__VITE_ASSET__jKutV_I$__"